import { compose, composeU } from '@bem-react/core';
import {
    Button as ButtonPresenter,
    withPinClearRound,
    withSizeL,
    withSizeM,
    withSizeS,
    withThemeAction,
    withThemeNormal,
    withTypeLink,
    withTypeSubmit
} from '@yandex-lego/components/Button/desktop';

const Button = compose(
    composeU(withThemeNormal, withThemeAction),
    composeU(withTypeLink, withTypeSubmit),
    composeU(withSizeL, withSizeM, withSizeS),
    withPinClearRound
)(ButtonPresenter);

// @ts-ignore
if (typeof global.requestAnimationFrame === 'undefined') {
    // @ts-ignore
    // eslint-disable-next-line
    global.requestAnimationFrame = () => {};
}

export default Button;
